/* global axios */
import ApiClient from './ApiClient';
import { resourcePath, requestConfig, withQuery } from './lais/httpHelpers';

class PartnersAPI extends ApiClient {
  constructor() {
    super('partner_organizations', { accountScoped: true });
  }

  get accountUrl() {
    return this.url.replace(/\/partner_organizations$/, '');
  }

  listOrganizations(params = {}) {
    return axios.get(withQuery(this.url, params), requestConfig());
  }

  showOrganization(id) {
    return axios.get(resourcePath(this.url, id), requestConfig());
  }

  createOrganization(payload = {}) {
    return axios.post(
      this.url,
      { partner_organization: payload },
      requestConfig()
    );
  }

  updateOrganization(id, payload = {}) {
    return axios.patch(
      resourcePath(this.url, id),
      {
        partner_organization: payload,
        expected_lock_version: payload.expected_lock_version,
      },
      requestConfig()
    );
  }

  publishAgreement(partnerId, payload = {}) {
    return axios.post(
      resourcePath(this.url, partnerId, 'publish_agreement'),
      { agreement: payload },
      requestConfig()
    );
  }

  listServiceWorkOrders(params = {}, partnerId = null) {
    const basePath = partnerId
      ? resourcePath(this.url, partnerId, 'service_work_orders')
      : resourcePath(this.accountUrl, 'service_work_orders');
    return axios.get(withQuery(basePath, params), requestConfig());
  }

  showServiceWorkOrder(id, partnerId = null) {
    return axios.get(this.serviceWorkOrderPath(id, partnerId), requestConfig());
  }

  createServiceWorkOrder(partnerId, payload = {}) {
    return axios.post(
      resourcePath(this.url, partnerId, 'service_work_orders'),
      payload,
      requestConfig()
    );
  }

  transitionServiceWorkOrder(id, action, payload = {}, partnerId = null) {
    return axios.post(
      resourcePath(this.serviceWorkOrderPath(id, partnerId), action),
      payload,
      requestConfig()
    );
  }

  grantAccess(id, payload = {}, partnerId = null) {
    return this.transitionServiceWorkOrder(
      id,
      'grant_access',
      payload,
      partnerId
    );
  }

  revokeAccess(id, payload = {}, partnerId = null) {
    return this.transitionServiceWorkOrder(
      id,
      'revoke_access',
      payload,
      partnerId
    );
  }

  serviceWorkOrderPath(id, partnerId = null) {
    if (partnerId) {
      return resourcePath(this.url, partnerId, 'service_work_orders', id);
    }
    return resourcePath(this.accountUrl, 'service_work_orders', id);
  }
}

export default new PartnersAPI();
